import { Box, Flex, Text } from '@chakra-ui/react'
import { format } from 'date-fns'
import { GoAlert } from 'react-icons/go'
import { formatPrice } from '../../../utils/formatPrice'
import React from 'react'

export function Transportadora({ dadosTransportadora, numeroNota }) {
    return (
        <Box
            gridColumn={{
                base: 'span 12',
                md: 'span 4',
            }}
            border="1px solid #7fb603"
        >
            <Text textAlign="center" color="#fff" bg="#7fb603">
                DADOS DA TRANSPORTADORA
            </Text>
            <Flex flexDir="column" gap={1} p={3}>
                <Text>
                    <b>Saída da mercadoria da fábrica: </b>
                    {dadosTransportadora.saida_mercadoria && format(new Date(dadosTransportadora.saida_mercadoria), 'dd/MM/yyyy')}
                </Text>
                <Text>
                    <b>Entregue por: </b>
                    {dadosTransportadora.transportadora}
                </Text>

                <Text>
                    <b>Valor real frete:</b> {formatPrice(parseFloat(dadosTransportadora.valor_frete_30))}
                </Text>

                <Flex alignItems="center" gap={2}>
                    <Text as="label" htmlFor="freteDestacado" fontWeight="bold">
                        Frete destaca Nota:
                    </Text>
                    {formatPrice(parseFloat(dadosTransportadora.valor_frete_30))}
                </Flex>

                <Flex color="#ff7e00" alignItems="center" my={2}>
                    <GoAlert />
                    <Text ml={2}>Importante</Text>
                </Flex>

                <Text>Não nos responsabilizamos por eventuais atrasos na entrega de seus produtos por meio de transportadoras ou correios.</Text>
            </Flex>
        </Box>
    )
}
